export default __webpack_public_path__ + "static/media/benefit-2@2x.528716e3.png";